<template>
  <div class="out-analysis">
    <mu-paper :z-depth="2" class="search">
      <mu-form :model="form" label-width="80" class="form" :inline="true">
        <mu-form-item prop="search" label="开始时间" label-position="left">
          <mu-date-input container="dialog" v-model="form.startTime"></mu-date-input>
        </mu-form-item>
        <mu-form-item prop="search" label="结束时间" label-position="left">
          <mu-date-input container="dialog" v-model="form.endTime"></mu-date-input>
        </mu-form-item>
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          查找
        </mu-button>
      </mu-form>
    </mu-paper>
    <div class="content">
      <mu-paper class="chart" :z-depth="2">
        <v-chart :options="chart" ref="chart" @click="chartClick" />
      </mu-paper>
      <mu-paper class="table" :z-depth="2">
        <mu-data-table
          :columns="columns"
          :data="chartData"
          stripe
          class="table"
          :loading="loading"
          @row-click="rowClick"
        >
          <template slot-scope="scope">
            <td>{{ scope.row.outCategory.name }}</td>
            <td>{{ scope.row.sum.value() }}</td>
          </template>
        </mu-data-table>
      </mu-paper>
    </div>
    <mu-dialog
      title="查看开支"
      width="500"
      :open="open"
      @close="close"
      scrollable
    >
      <mu-data-table
        :columns="columns2"
        :data="list.filter((x) => x.outCategory.id === selectOutCategoryId)"
        stripe
        class="view-table"
      >
        <template slot-scope="scope">
          <td>{{ moment(scope.row.createTime).format('YYYY-MM-DD') }}</td>
          <td>{{ scope.row.name }}</td>
          <td>{{ scope.row.sum }}</td>
        </template>
      </mu-data-table>
      <mu-button slot="actions" flat color="secondary" @click="close">
        关闭
      </mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import moment from 'moment'
import backend from 'utils/backend'
import api from '@/api'
import numeral from 'numeral'
export default {
  components: {
    'v-chart': ECharts
  },
  data() {
    return {
      moment,
      open: false,
      loading: false,
      form: {
        relations: ['out.user', 'out.outCategory'],
        getAll: true,
        startTime: moment().startOf('month').toDate(),
        endTime: moment().endOf('month').toDate()
      },
      chartData: [],
      list: [],
      chart: {
        title: {
          text: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 10,
          top: 30,
          data: []
        },
        series: [
          {
            name: '开支',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      columns: [
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '金额',
          name: 'sum',
          align: 'center',
          width: 150
        }
      ],
      columns2: [
        {
          title: '日期',
          name: 'createTime',
          align: 'center'
        },
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '金额',
          name: 'sum',
          align: 'center',
          width: 150
        }
      ],
      selectOutCategoryId: 0
    }
  },
  methods: {
    getAll() {
      this.loading = true
      backend(api.out.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          const chartData = []
          const total = numeral(0)
          this.list = result.data.rows
          result.data.rows.forEach((item) => {
            total.add(item.sum)
            const exist = chartData.find(
              (x) => x.outCategory.id === item.outCategory.id
            )
            if (exist) {
              exist.sum.add(item.sum)
              exist.outs.push(item)
            } else {
              chartData.push({
                outCategory: item.outCategory,
                outs: [item],
                sum: numeral(item.sum)
              })
            }
          })
          chartData.sort((a, b) => b.sum.value() - a.sum.value())
          this.chartData = chartData
          this.loading = false
          this.$refs.chart.mergeOptions({
            title: {
              text: `${moment(this.form.startTime).format(
                'YYYY年M月D日'
              )}-${moment(this.form.endTime).format(
                'YYYY年M月D日'
              )}总开支${total.value()}元`
            },
            legend: {
              data: chartData.map((item) => item.outCategory.name)
            },
            series: [
              {
                data: chartData.map((item) => ({
                  name: item.outCategory.name,
                  value: item.sum.value(),
                  id: item.outCategory.id
                }))
              }
            ]
          })
        }
      })
    },
    close() {
      this.open = false
    },
    chartClick(e) {
      this.selectOutCategoryId = e.data.id
      this.open = true
    },
    rowClick(index, row) {
      this.selectOutCategoryId = row.outCategory.id
      this.open = true
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="less" scoped>
.out-analysis {
  display: flex;
  flex-direction: column;
  .search {
    padding: 16px;
    .title {
      font-size: 18px;
    }
  }
  .content {
    flex: 1;
    margin-top: 20px;
    display: flex;
    .chart {
      flex: 0 0 60%;
    }
    .table {
      flex: 1;
      margin-left: 20px;
      td {
        text-align: center;
      }
    }
  }
}
.view-table {
  td {
    text-align: center;
  }
}
</style>
<style>
.echarts {
  width: 100% !important;
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/reporter/out.vue